export default "__VITE_ASSET__oH$j9Dsz__"